import { Link } from '@/components/Elements';
import { Button } from '@/components/Elements/Button';
import { ToggleSwitch } from '@/components/ToggleSwitch';
import {
  PriceDisplay,
  PromotionPrice,
} from '@/features/subscription/components';
import { SubscriptionLayout } from '@/features/subscription/components/SubscriptionLayout';
import { useSubscription } from '@/features/subscription/hooks/useSubscription';
import { useUserPermission } from '@/lib/auth';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const Subscription = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const promotion = new URLSearchParams(location.search).get('promotion');
  const displayBasicLink = location.state?.display_basic != false;

  const {
    isYearly,
    setIsYearly,
    error,
    currentPrice,
    yearlyDiscountPercentage,
    handleSubscribe,
    isMutating,
  } = useSubscription(promotion);
  const { data: user } = useUserPermission();

  return (
    <SubscriptionLayout>
      <h2 className="text-2xl font-semibold text-gray-900 md:text-3xl">
        RuleWatcher Plus
      </h2>
      <p className="mb-6 mt-2 text-base text-gray-600 md:text-lg">
        {t('追加の社会課題テーマと、より高度な分析機能をご利用いただけます。')}
      </p>

      <ToggleSwitch
        checked={isYearly}
        onToggle={(checked) => setIsYearly(checked)}
        labels={[t('月払い'), t('年払い')]}
      />

      <PriceDisplay
        price={currentPrice}
        discountPercentage={yearlyDiscountPercentage}
        recurringInterval={isYearly ? 'year' : 'month'}
      />

      <PromotionPrice price={currentPrice} />

      {user && !user.hasTrialHistory && (
        <p className="mb-6 mt-2 text-base text-gray-600 md:text-lg">
          {t('１４日フリートライアルで開始できます。')}
          {t('フリートライアル期間中に解約することもできます。')}
        </p>
      )}

      <div className="mt-8 space-y-4">
        <Button
          onClick={handleSubscribe}
          isLoading={isMutating}
          disabled={isMutating}
          color="dark"
          size="lg"
          className="w-full"
        >
          {t('Plusプランで始める')}
        </Button>
        {displayBasicLink && (
          <Link
            to="/themes"
            className="block w-full text-center text-sm"
            color="secondary"
            underline="hover"
          >
            {t('Basic(無料)プランではじめる')}
          </Link>
        )}
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    </SubscriptionLayout>
  );
};
